// image files
import pokeballImg      from "../assets/images/items/pokeball.png";
import greatballImg     from "../assets/images/items/greatball.png";
import ultraballImg     from "../assets/images/items/ultraball.png";
import rangeballImg     from "../assets/images/items/rangeball.png";
import longballImg      from "../assets/images/items/longball.png";
import mudballImg      from "../assets/images/items/mudball.png";
import rubyballImg      from "../assets/images/items/rubyball.png";
import sapphireballImg  from "../assets/images/items/sapphireball.png";
import emeraldballImg      from "../assets/images/items/emeraldball.png";
import goldenballImg      from "../assets/images/items/goldenball.png";
import diamondballImg      from "../assets/images/items/diamondball.png";
import shadowballImg      from "../assets/images/items/shadowball.png";
import masterballImg      from "../assets/images/items/masterball.png";
import rubyGummyImg      from "../assets/images/items/ruby-gummy.png";
import sapphireGummyImg  from "../assets/images/items/sapphire-gummy.png";
import emeraldGummyImg      from "../assets/images/items/emerald-gummy.png";
import goldenGummyImg      from "../assets/images/items/golden-gummy.png";
import diamondGummyImg      from "../assets/images/items/diamond-gummy.png";
import scentofGengarImg      from "../assets/images/items/scentofgengar.png";
import lureImg          from "../assets/images/items/lure.png";
import superLureImg     from "../assets/images/items/superlure.png";
import ultraLureImg     from "../assets/images/items/ultralure.png";
import rawstberryImg     from "../assets/images/items/rawstberry.png";
import sitrusberryImg     from "../assets/images/items/sitrusberry.png";
import aspearberryImg     from "../assets/images/items/aspearberry.png";
import razzberryImg     from "../assets/images/items/razzberry.png";
import heartberryimg     from "../assets/images/items/heartberry.png";
import magostberryImg     from "../assets/images/items/magostberry.png";
import figyBerryImg from "../assets/images/items/figyberry.png";
import lumberryImg from "../assets/images/items/lumberry.png";
import aguavberryImg from "../assets/images/items/aguavberry.png";
import oranberryimg from "../assets/images/items/oranberry.png";
import pechaberryimg from "../assets/images/items/pechaberry.png";
import wikiberryimg from "../assets/images/items/wikiberry.png";
import pouchIcon   from "../assets/images/items/pouch.png";
// potions
import potionImg       from "../assets/images/items/potion.png";
import superPotionImg  from "../assets/images/items/superpotion.png";
import hyperPotionImg  from "../assets/images/items/hyperpotion.png";
import maxPotionImg    from "../assets/images/items/maxpotion.png";
import diglettSpriteSheet from "../assets/images/DiglettDashSpriteSheet.png";
import tunnelTrackImg from "../assets/images/DiglettDashMap.png";
// import mineralPotionImg  from "../assets/images/items/MineralPotion.png";
// import shinyPotionImg   from "../assets/images/items/ShinyPotion.png";
// mining items
import mineLureImg      from "../assets/images/items/mininglure.png";
import dropLureImg       from "../assets/images/items/exp2lure.png";
import amuletMineImg    from "../assets/images/items/amuletmine.png";
import rubycrown    from "../assets/images/items/rubycrown.png";
import sapphirecrown    from "../assets/images/items/sapphirecrown.png";
import emeraldcrown    from "../assets/images/items/emeraldcrown.png";
import goldencrown    from "../assets/images/items/goldencrown.png";
import diamondcrown    from "../assets/images/items/diamondcrown.png";

// “throwing” sprites
import pokeballSprite   from "../assets/images/pokemon_maps/items/pokeball.png";
import greatballSprite  from "../assets/images/pokemon_maps/items/greatball.png";
import ultraballSprite  from "../assets/images/pokemon_maps/items/ultraball.png";
import longballSprite   from "../assets/images/pokemon_maps/items/longball.png";
import rangeballSprite  from "../assets/images/pokemon_maps/items/rangeball.png";
import masterballSprite from "../assets/images/pokemon_maps/items/masterball.png";
import mudballSprite from "../assets/images/pokemon_maps/items/mudball.png";
import rubyballSprite from "../assets/images/pokemon_maps/items/rubyball.png";
import sapphireballSprite from "../assets/images/pokemon_maps/items/sapphireball.png";
import emeraldballSprite from "../assets/images/pokemon_maps/items/emeraldball.png";
import shadowballSprite from "../assets/images/pokemon_maps/items/shadowball.png";
import goldenballSprite from "../assets/images/pokemon_maps/items/goldenball.png";
import diamondballSprite from "../assets/images/pokemon_maps/items/diamondball.png";

import normalPickaxeImg from "../assets/images/items/NormalPickaxe.png";
import rubyPickaxeImg   from "../assets/images/items/RubyPickaxe.png";
import emeraldPickaxeImg from "../assets/images/items/EmeraldPickaxe.png";
import goldPickaxeImg   from "../assets/images/items/GoldenPickaxe.png";
import diamondPickaxeImg from "../assets/images/items/DiamondPickaxe.png";
import sapphirePickaxeImg from "../assets/images/items/SapphirePickaxe.png";






// IDs (match your back-end)
export const POKEBALL_ITEM_ID   = 2;
export const GREATBALL_ITEM_ID  = 3;
export const ULTRABALL_ITEM_ID  = 4;
export const LONGBALL_ITEM_ID   = 4000;
export const RANGEBALL_ITEM_ID  = 4001;
export const MUDBALL_ITEM_ID    = 4002;
export const RUBYBALL_ITEM_ID   = 4003;
export const SAPPHIREBALL_ITEM_ID = 4004;
export const EMERALDBALL_ITEM_ID = 4005;
export const GOLDENBALL_ITEM_ID = 4006;
export const DIAMONDBALL_ITEM_ID = 4007;
export const SHADOWBALL_ITEM_ID = 4008;
export const MASTERBALL_ITEM_ID = 63;

export const LURE_ITEM_ID       = 214;
export const SUPER_LURE_ITEM_ID = 701780;
export const ULTRA_LURE_ITEM_ID = 701781;
export const MINING_POTION = 234;
export const DROP_POTION_ID = 235;
export const MINERAL_POTION_ID = 116;
export const SHINY_POTION_ID = 117;
export const SCENT_GENGAR_ID = 167;
// re-export images and sprites
export {
  pokeballImg, greatballImg, ultraballImg,
  rangeballImg, longballImg, mudballImg, rubyballImg, sapphireballImg, emeraldballImg, goldenballImg, diamondballImg,
  lureImg, superLureImg, ultraLureImg,
  pokeballSprite, greatballSprite, ultraballSprite,masterballSprite,
  longballSprite, rangeballSprite, 
  diamondGummyImg,goldenGummyImg,rubyGummyImg,sapphireGummyImg,emeraldGummyImg,
  potionImg, superPotionImg, hyperPotionImg, maxPotionImg,
  mineLureImg, dropLureImg, amuletMineImg,pouchIcon,/* mineralPotionImg,shinyPotionImg,*/shadowballSprite,scentofGengarImg,rawstberryImg,    sitrusberryImg,razzberryImg,
  magostberryImg,aspearberryImg,figyBerryImg,lumberryImg,aguavberryImg,oranberryimg,pechaberryimg,wikiberryimg,heartberryimg,
  mudballSprite, rubyballSprite, sapphireballSprite, emeraldballSprite, goldenballSprite, diamondballSprite, diglettSpriteSheet,tunnelTrackImg,shadowballImg, masterballImg
};



export const pickaxeIcons = {
  228: normalPickaxeImg,
  229: rubyPickaxeImg,
  233: sapphirePickaxeImg,
  230: emeraldPickaxeImg,
  231: goldPickaxeImg,
  232: diamondPickaxeImg,
};

export const pickaxeDurability = {
  228: 50,
  229: 200,
  230: 150,
  231: 75,
  232: 250,
  233: 200,
};

// Sell prices mapping
export const sellPrices = {
  rock:      5,
  ruby:      75,
  sapphire:  75,
  emerald:  100,
  gold:     200,
  diamond:  400,
  // Stone items
  fire_stone:    200,
  water_stone:   200,
  thunder_stone: 200,
  leaf_stone:    200,
  moon_stone:    200,
  dawn_stone:    200,
  metal_coat:    200,
  kings_rock:    200,
};

export const pickaxeCosts = {
  228: 500,
  229: "25",
  230: "50",
  231: "35",
  232: "25",
  233: "25",
};

// store item info for mining shop
// Level requirements for helmets, crowns, pickaxes, and special Pokéballs
export const LEVEL_REQUIREMENTS = {
  // Helmets
  16: 45,   // Ruby Helmet
  18: 45,   // Sapphire Helmet  
  19: 80,   // Emerald Helmet
  20: 120,  // Golden Helmet
  21: 180,  // Diamond Helmet
  // Crowns
  11: 130,  // Ruby Crown
  12: 130,  // Sapphire Crown
  13: 200,  // Emerald Crown
  14: 250,  // Golden Crown
  15: 300,  // Diamond Crown
  // Pickaxes
  228: 1,    // Stone Pickaxe
  229: 25,   // Ruby Pickaxe
  233: 25,   // Sapphire Pickaxe
  230: 50,   // Emerald Pickaxe
  231: 100,  // Gold Pickaxe
  232: 200,  // Diamond Pickaxe
  // Special Pokéballs
  4003: 100, // Rubyball
  4004: 100, // Sapphireball
  4005: 200, // Emeraldball
  4008:300,
  4006: 400, // Goldenball
  4007: 500, // Diamondball,
  // Mining Items
  121: 150,  // Mining Charm,
  // Special Rings
  140: 600,  // Ring of Department
};

export const storeItemInfo = {
  234: {
    name: "Mining Potion",
    description: "An item that doubles the amount of mining experience earned. (50 Hits)",
    cost: { coins: 1000 },
    icon: mineLureImg,
  },
  235: {
    name: "Drop Potion",
    description: "An item that doubles your drop percentages for your pickaxe. (50 Hits)",
    cost: { emerald: 15 },
    icon: dropLureImg,
  },
  240: {
    name: "Amulet of Mining",
    description: "An equipable amulet that doubles the amount mining experience earned.",
    cost: { diamond: 150 },
    icon: amuletMineImg,
  },
  // Helmets
  16: {
    name: "Ruby Helmet",
    description: "An equipable helmet that gives a +10% chance to uncover Rubies when mining rocks.",
    cost: { ruby: 500 },
    icon: null, // Add helmet icon if available
    levelRequired: 45,
  },
  18: {
    name: "Sapphire Helmet",
    description: "An equipable helmet that gives a +10% chance to uncover Sapphires when mining rocks.",
    cost: { sapphire: 500 },
    icon: null, // Add helmet icon if available
    levelRequired: 45,
  },
  19: {
    name: "Emerald Helmet",
    description: "An equipable helmet that gives a +10% chance to uncover Emeralds when mining rocks.",
    cost: { emerald: 500 },
    icon: null, // Add helmet icon if available
    levelRequired: 80,
  },
  20: {
    name: "Golden Helmet",
    description: "An equipable helmet that gives a +10% chance to uncover Gold when mining rocks.",
    cost: { gold: 500 },
    icon: null, // Add helmet icon if available
    levelRequired: 120,
  },
  21: {
    name: "Diamond Helmet",
    description: "An equipable helmet that gives a +10% chance to uncover Diamonds when mining rocks.",
    cost: { diamond: 500 },
    icon: null, // Add helmet icon if available
    levelRequired: 180,
  },
  // Crowns
  11: {
    name: "Ruby Crown",
    description: "An equipable crown that gives a +10% chance to uncover Rubies when mining rocks.",
    cost: { ruby: 1000 },
    icon: rubycrown,
    levelRequired: 130,
  },
  12: {
    name: "Sapphire Crown",
    description: "An equipable crown that gives a +10% chance to uncover Sapphires when mining rocks.",
    cost: { sapphire: 1000 },
    icon: sapphirecrown,
    levelRequired: 130,
  },
  13: {
    name: "Emerald Crown",
    description: "An equipable crown that gives a +10% chance to uncover Emeralds when mining rocks.",
    cost: {emerald: 1000 },
    icon: emeraldcrown,
    levelRequired: 200,
  },
    14: {
    name: "Golden Crown",
    description: "An equipable crown that gives a +10% chance to uncover Gold when mining rocks.",
    cost: {gold: 1000 },
    icon: goldencrown,
    levelRequired: 250,
  },
  15: {
    name: "Diamond Crown",
    description: "An equipable crown that gives a +10% chance to uncover Gold when mining rocks.",
    cost: {diamond: 1000 },
    icon: diamondcrown,
    levelRequired: 300,
  },
};

// Helper functions
export function getLevel(exp) {
  const lvl = Math.floor(Math.pow(exp, 1 / 3));
  return Math.pow(lvl + 1, 3) <= exp ? lvl + 1 : lvl;
}

export function getCatcherLevel(exp) {
  const lvl = Math.floor(Math.pow(exp, 1 / 2.5));
  return Math.pow(lvl + 1, 2.5) <= exp ? lvl + 1 : lvl;
}

export function getMiningLevel(exp) {
  const lvl = Math.floor(Math.pow(exp, 1 / 2.5));
  return Math.pow(lvl + 1, 2.5) <= exp ? lvl + 1 : lvl;
}

export function getFishingLevel(exp) {
  const lvl = Math.floor(Math.pow(exp, 1 / 2.5));
  return Math.pow(lvl + 1, 2.5) <= exp ? lvl + 1 : lvl;
}

export function getFarmingLevel(exp) {
  const lvl = Math.floor(Math.pow(exp, 1 / 2.5));
  return Math.pow(lvl + 1, 2.5) <= exp ? lvl + 1 : lvl;
}

// Drop rates per pickaxe (rock is implicit: 1 - sum of all gem rates)
// Backend rates: 65% rock, 12% ruby, 12% sapphire, 6% emerald, 4% gold, 1% diamond
export const pickaxeDropRates = {
  228: { rock: 0.65, ruby: 0.12, sapphire: 0.12, emerald: 0.06, gold: 0.04, diamond: 0.01 },
  229: { rock: 0.65, ruby: 0.12, sapphire: 0.12, emerald: 0.06, gold: 0.04, diamond: 0.01 },
  233: { rock: 0.65, ruby: 0.12, sapphire: 0.12, emerald: 0.06, gold: 0.04, diamond: 0.01 },
  230: { rock: 0.65, ruby: 0.12, sapphire: 0.12, emerald: 0.06, gold: 0.04, diamond: 0.01 },
  231: { rock: 0.65, ruby: 0.12, sapphire: 0.12, emerald: 0.06, gold: 0.04, diamond: 0.01 },
  232: { rock: 0.65, ruby: 0.12, sapphire: 0.12, emerald: 0.06, gold: 0.04, diamond: 0.01 },
};

export const pickaxeRequirements = {
  228: 1,
  229: 25,
  230: 50,
  231: 100,
  232: 200,
  233: 25,
};
